export default "__VITE_ASSET__DilKkpf$__"